export enum FileActionsDictionary {
  SHARE = 'SHARE',
  UNSHARE = 'UNSHARE',
  DELETE = 'DELETE',
  RENAME = 'RENAME',
  CREATE = 'CREATE',
  COPY = 'COPY',
  MOVE = 'MOVE'
}
